import { Sentry } from '@/lib/sentry'

function ErrorFallback() {
  return (
    <div style={{ padding: '3rem', textAlign: 'center', maxWidth: '500px', margin: '4rem auto' }}>
      <h2 style={{ marginBottom: '1rem', color: 'var(--color-gray-900)' }}>Something went wrong</h2>
      <p style={{ marginBottom: '2rem', color: 'var(--color-gray-600)' }}>
        An unexpected error occurred. Please try reloading the page.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '0.75rem 1.5rem',
          borderRadius: '8px',
          border: 'none',
          backgroundColor: 'var(--color-sky-blue)',
          color: 'white',
          fontSize: '0.875rem',
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload Page
      </button>
    </div>
  )
}

export function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
